export default __webpack_public_path__ + "static/media/Corsairs-treasure-09.46cad700.png";